import React, { useEffect, useState } from "react";
import { Box, Button, FormControl, Grid, InputLabel, Select, TextField, Typography } from '@mui/material';
import { Search as IconSearch } from '@mui/icons-material';
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import DataGridBase from "../../components/common/DataGridBase";
import DialogYesNo from "../../components/common/DialogYesNo";
import * as terapiaService from "../../services/terapiaService";
import * as descuentoService from "../../services/descuentoService";
import * as catalogoService from "../../services/catalogoService";
import moment from "moment";

const Descuentos = () => {
    const [participante, setParticipante] = useState("");
    const [periodo, setPeriodo] = useState(0);
    const [estado, setEstado] = useState(0);
    const [rows, setRows] = useState([]);
    const [allRows, setAllRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [listPeriodos, setListPeriodos] = useState([]);
    const [listEstados, setListEstados] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectIdDescuento, setSelectIdDescuento] = useState(0);
    // Anular un descuento lo pide la API con "descuento.anular": sin ese
    // acceso el enlace no se muestra, para no dejar el 403 al pulsarlo.
    const accesos = useSelector((state) => state.seguridad?.accesos) || [];
    const seguridadActiva = useSelector((state) => state.seguridad?.seguridadActiva) || "N";
    const puedeAnular = seguridadActiva !== "S" || accesos.length === 0
        || accesos.includes("descuento.anular");

    useEffect(() => {
        (async () => {
            const data = await catalogoService.getCatalogosByPadre(1).catch(() => []);
            setListEstados(data || []);
        })();
        buscar();
    }, []);

    const buscar = async () => {
        setLoading(true);
        const data = await terapiaService.getsTerapiaPeriodoResumenView({
            idPeriodo: 0, idFilial: 0, idTipoTerapia: 0, participante: participante || "",
            idTerapeuta: 0, terapeuta: "", idEstado: 0, idTerapiaPeriodo: 0,
        }).catch((err) => { console.log(err); return []; });
        const filtrados = (data || []).filter((r) => r.idDescuento && r.idDescuento > 0);
        setAllRows(filtrados);
        aplicarFiltros(filtrados, periodo, estado);
        const periodosUnicos = [...new Set(filtrados.map((r) => r.codigoPeriodo).filter(Boolean))];
        setListPeriodos(periodosUnicos);
        setLoading(false);
    };

    const aplicarFiltros = (base, p, e) => {
        let out = base || [];
        if (p && p !== 0 && p !== "0") out = out.filter((r) => r.codigoPeriodo === p);
        if (e && e !== 0) out = out.filter((r) => r.idEstadoDescuento === e);
        setRows(out);
    };

    useEffect(() => { aplicarFiltros(allRows, periodo, estado); }, [periodo, estado, allRows]);

    const anular = async () => {
        try {
            await descuentoService.annulDescuento(selectIdDescuento);
            setOpenDialog(false);
            await buscar();
        } catch (e) {
            console.log(e);
            setOpenDialog(false);
            const msg = e?.response?.data?.detail || e?.response?.data?.Detail || "No se pudo anular el descuento.";
            alert(msg);
        }
    };

    const columns = [
        { field: 'id', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        { field: 'codigoFilial', headerName: 'Filial', width: 70, headerAlign: 'center', align: 'center' },
        { field: 'participante', headerName: 'Participante', width: 175 },
        { field: 'terapeuta', headerName: 'Terapeuta', width: 175 },
        { field: 'codigoPeriodo', headerName: 'Periodo', width: 90, headerAlign: 'center', align: 'center' },
        { field: 'codigoDescuento', headerName: 'Cod. Descuento', width: 120 },
        { field: 'montoDescuento', headerName: 'Monto Descuento', width: 130,
            valueFormatter: (v) => v == null ? "" : (parseFloat(v) || 0).toFixed(2)
        },
        { field: 'fechaInicioDescuento', headerName: 'Inicio Desc.', width: 120,
            valueFormatter: (v) => (v && moment(v).isValid() ? moment(v).format("DD/MM/YYYY") : "")
        },
        { field: 'fechaFinDescuento', headerName: 'Fin Desc.', width: 120,
            valueFormatter: (v) => (v && moment(v).isValid() ? moment(v).format("DD/MM/YYYY") : "")
        },
        { field: 'idEstadoDescuento', headerName: 'Estado Desc.', width: 110,
            valueFormatter: (v) => (v === 2 ? "Activo" : (v === 4 ? "Anulado" : "Inactivo"))
        },
        { field: 'anular', headerName: 'Anular', width: 90,
            renderCell: (cellValues) => (
                cellValues.row.idEstadoDescuento === 2 ? (
                    puedeAnular ? (
                        <Box onClick={() => { setSelectIdDescuento(cellValues.row.idDescuento); setOpenDialog(true); }}
                            style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                            Anular
                        </Box>
                    ) : <span style={{ color: '#999' }}>—</span>
                ) : <span style={{ color: '#999' }}>Anulado</span>
            )
        }
    ];

    return (
        <Grid container>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Descuentos</Typography>
            <Grid container spacing={1} padding="12px 0px">
                <Grid item xs={12} sm={4}>
                    <TextField label="Participante" fullWidth size="small" value={participante}
                        onChange={(e) => setParticipante(e.target.value)}
                        onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); buscar(); } }} />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Periodo</InputLabel>
                        <Select native value={periodo} onChange={(e) => setPeriodo(e.target.value === "" ? 0 : e.target.value)} label="Periodo">
                            <option value={0}>(Todos)</option>
                            {listPeriodos.map((p) => <option key={p} value={p}>{p}</option>)}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Estado</InputLabel>
                        <Select native value={estado} onChange={(e) => setEstado(parseInt(e.target.value) || 0)} label="Estado">
                            <option value={0}>(Todos)</option>
                            {(listEstados || []).map((e) => <option key={e.id || e.idCatalogo} value={e.id || e.idCatalogo}>{e.descripcion}</option>)}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={4} sm={2}>
                    <Button variant="outlined" fullWidth onClick={buscar}><IconSearch /></Button>
                </Grid>
            </Grid>
            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                <DataGridBase rows={rows} columns={columns} loading={loading} />
            </Box>
            <DialogYesNo open={openDialog} openClose={() => setOpenDialog(false)} setYes={anular} setNo={() => setOpenDialog(false)}
                titulo="Anular descuento" texto="Confirma la anulacion del descuento?" />
        </Grid>
    );
};

export default Descuentos;